export const addBranding = async (context: CanvasRenderingContext2D, canvas: HTMLCanvasElement) => {
    context.save()
    const logo = new Image()

    try {
        await new Promise((resolve, reject) => {
            logo.onload = () => resolve(true)
            logo.onerror = (e) => {
                console.error('Error loading logo', e)
                reject(new Error('Failed to load logo'))
            }

            const logoPath = window.location.origin + '/bitquery_logo_w.png'
            logo.setAttribute('src', logoPath)
        })

        context.globalAlpha = 0.4

        // Watermark sized to half the canvas width and centred, keeping the
        // logo's own aspect ratio so it never overflows / gets clipped.
        const logoWidth = canvas.width * 0.5
        const logoHeight = (logoWidth / logo.naturalWidth) * logo.naturalHeight
        const x = (canvas.width - logoWidth) / 2
        const y = (canvas.height - logoHeight) / 2

        context.drawImage(logo, x, y, logoWidth, logoHeight)
    } catch (error) {
        console.error('Failed to add branding:', error)
    } finally {
        context.restore()
    }
}
